var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddCircle = function SvgAddCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "add_circle_svg__a",
    width: 27,
    height: 27,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h27v27H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#add_circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.375 14.625V18q0 .478.323.802.324.323.802.323t.802-.323.323-.802v-3.375H18q.478 0 .802-.323.323-.324.323-.802t-.323-.802a1.1 1.1 0 0 0-.802-.323h-3.375V9q0-.478-.323-.802a1.1 1.1 0 0 0-.802-.323q-.478 0-.802.323a1.1 1.1 0 0 0-.323.802v3.375H9q-.478 0-.802.323a1.1 1.1 0 0 0-.323.802q0 .478.323.802.324.323.802.323zM13.5 24.75q-2.335 0-4.387-.886A11.4 11.4 0 0 1 5.54 21.46a11.4 11.4 0 0 1-2.405-3.572A11 11 0 0 1 2.25 13.5q0-2.335.886-4.387A11.4 11.4 0 0 1 5.54 5.54a11.4 11.4 0 0 1 3.572-2.405A11 11 0 0 1 13.5 2.25q2.335 0 4.387.886A11.4 11.4 0 0 1 21.46 5.54a11.4 11.4 0 0 1 2.405 3.572q.886 2.052.886 4.387t-.886 4.387a11.4 11.4 0 0 1-2.405 3.572 11.4 11.4 0 0 1-3.572 2.405q-2.052.886-4.387.886m0-2.25q3.768 0 6.384-2.616T22.5 13.5t-2.616-6.384T13.5 4.5q-3.768 0-6.384 2.616T4.5 13.5t2.616 6.384T13.5 22.5"
  }))));
};
export default SvgAddCircle;